import ContentfulSection from '../ContentfulSection';

const PageUnauthenticatedView = ({ sections }) =>
  sections.map((props: any) => props && <ContentfulSection key={props?.id} {...props} />);

export default PageUnauthenticatedView;
